import {
  BoardIds,
  FilterIdentifier,
  FilterUserSelection,
} from "../../common/generic/generic-filters-boards-attributes";
import { BuildUrlForHyperlinkInGrid } from "../../common/generic/generic-helper";
import {
  IGenericAggregateResponse,
  IGenericHyperlinkFilter,
} from "../../common/generic/generic-types";
import { IPortfolioClientList } from "../../common/portfolio/portfolio-types";
import { Functions } from "../../common/utils/clientlistHelper";
import { getAllHeaders } from "../utils/Headers";
export class NbiClientListOutput {
  public constructor(public data: IPortfolioClientList[]) {}
}

// tslint:disable-next-line:cognitive-complexity
// tslint:disable-next-line:no-big-function
export function MapData(data: IGenericAggregateResponse) {
  if (!data.aggregates || data.aggregates.length === 0) {
    return new NbiClientListOutput([]);
  }
  const topValues: any[] = [];
  // tslint:disable-next-line: no-big-function
  data.aggregates.forEach(element => {
    if (element.dimensionAttributeValues !== undefined) {
      const dateForFilter = [];
      if (data.request) {
        dateForFilter.push(data.request.date);
      }

      const clientId = element.dimensionAttributeValues.clientgen_id;
      const clientSubGroupId = element.dimensionAttributeValues.client_subgrpid;
      const clientLegalEntityId = element.dimensionAttributeValues.client_leid;
      const clientRctForLegalEntityId =
        element.dimensionAttributeValues.client_leid;
      const clientGroupNameId = element.dimensionAttributeValues.client_grpid;

      topValues.push({
        clientGroupNameHlink: GetHyperLinkForField(
          [clientGroupNameId],
          dateForFilter
        ),
        clientLegalEntityHlink: GetHyperLinkForField(
          [clientLegalEntityId],
          dateForFilter
        ),
        clientRctForLegalEntityHlink: GetHyperLinkForField(
          [clientRctForLegalEntityId],
          dateForFilter
        ),
        clientSubGroupHlink: GetHyperLinkForField(
          [clientSubGroupId],
          dateForFilter
        ),
        hlink: GetHyperLinkForField([clientId], dateForFilter),

        fpvBlHlink: GetHyperLinkForField(
          [clientId, element.dimensionAttributeValues.fpv_bl],
          undefined,
          [FilterIdentifier.client_account_picker, FilterIdentifier.fpv_bl],
          [
            FilterUserSelection.client_selector,
            `${FilterUserSelection.fpv_bls}bl`,
          ],
          BoardIds.Portfolio_DealExport
        ),
        fpv_bl: element.dimensionAttributeValues.fpv_bl,
        fpv_sbl: element.dimensionAttributeValues.fpv_sbl,
        fpv_ssbl: element.dimensionAttributeValues.fpv_ssbl,
        fpvSblHlink: GetHyperLinkForField(
          [clientId, element.dimensionAttributeValues.fpv_sbl],
          undefined,
          [FilterIdentifier.client_account_picker, FilterIdentifier.fpv_sbl],
          [
            FilterUserSelection.client_selector,
            `${FilterUserSelection.fpv_bls}sbl`,
          ],
          BoardIds.Portfolio_DealExport
        ),
        fpvSsblHlink: GetHyperLinkForField(
          [clientId, element.dimensionAttributeValues.fpv_ssbl],
          undefined,
          [FilterIdentifier.client_account_picker, FilterIdentifier.fpv_ssbl],
          [
            FilterUserSelection.client_selector,
            `${FilterUserSelection.fpv_bls}ssbl`,
          ],
          BoardIds.Portfolio_DealExport
        ),
        fpv_oeresregcode: element.dimensionAttributeValues.fpv_oeresregcode,
        fpv_oeshortlabel: element.dimensionAttributeValues.fpv_oeshortlabel,
        fpv_oeresctryname: element.dimensionAttributeValues.fpv_oeresctryname,
        fpv_beshortlabel: element.dimensionAttributeValues.fpv_beshortlabel,
        fpv_beresctryname: element.dimensionAttributeValues.fpv_beresctryname,
        agency_declongname: element.dimensionAttributeValues.agency_declongname,
        product_label: element.dimensionAttributeValues.product_label,
        product_code: element.dimensionAttributeValues.product_code,
        product_l1: element.dimensionAttributeValues.product_l1,
        product_l2: element.dimensionAttributeValues.product_l2,
        product_l3: element.dimensionAttributeValues.product_l3,
        clientgen_id: element.dimensionAttributeValues.clientgen_id,
        clientgen_name: element.dimensionAttributeValues.clientgen_name,
        client_corigrpcomid:
          element.dimensionAttributeValues.client_corigrpcomid,
        client_corigrpfullname:
          element.dimensionAttributeValues.client_corigrpfullname,
        client_corigrpctryname:
          element.dimensionAttributeValues.client_corigrpctryname,
        client_corigrpregion:
          element.dimensionAttributeValues.client_corigrpregion,
        client_corigrpsubregion:
          element.dimensionAttributeValues.client_corigrpsubregion,
        client_corigrpsegment:
          element.dimensionAttributeValues.client_corigrpsegment,
        client_coricountryaxis:
          element.dimensionAttributeValues.client_coricountryaxis,
        client_lename: element.dimensionAttributeValues.client_lename,
        client_leid: element.dimensionAttributeValues.client_leid,
        client_subgrpname: element.dimensionAttributeValues.client_subgrpname,
        client_corisectorlevel1:
          element.dimensionAttributeValues.client_corisectorlevel1,
        client_corisectorlevel2:
          element.dimensionAttributeValues.client_corisectorlevel2,
        client_corisectorlevel3:
          element.dimensionAttributeValues.client_corisectorlevel3,
        client_corigrplevel:
          element.dimensionAttributeValues.client_corigrplevel,
        salesben_saleslocation:
          element.dimensionAttributeValues.salesben_saleslocation,
        client_leadcoribanker:
          element.dimensionAttributeValues.client_leadcoribanker,
        client_countryofbusinessreview:
          element.dimensionAttributeValues.client_countryofbusinessreview,
        clientgen_fupclasslabel:
          element.dimensionAttributeValues.clientgen_fupclasslabel,
        client_id: element.dimensionAttributeValues.client_id,
        client_grpname: element.dimensionAttributeValues.client_grpname,
        client_grpcomctryname:
          element.dimensionAttributeValues.client_grpcomctryname,
        client_grpcomregname:
          element.dimensionAttributeValues.client_grpcomregname,
        client_grpcomsubregname:
          element.dimensionAttributeValues.client_grpcomsubregname,
        clientgen_segment: element.dimensionAttributeValues.clientgen_segment,
        clientgen_subregname:
          element.dimensionAttributeValues.clientgen_subregname,
        clientgen_ctryaxiscode:
          element.dimensionAttributeValues.clientgen_ctryaxiscode,
        clientgen_typol1name:
          element.dimensionAttributeValues.clientgen_typol1name,
        clientgen_typol2name:
          element.dimensionAttributeValues.clientgen_typol2name,
        clientgen_typol3name:
          element.dimensionAttributeValues.clientgen_typol3name,
        clientgen_comctrylabel:
          element.dimensionAttributeValues.clientgen_comctrylabel,
        client_lecomctryname:
          element.dimensionAttributeValues.client_lecomctryname,
        clientgen_regname: element.dimensionAttributeValues.clientgen_regname,
        clientgen_level: element.dimensionAttributeValues.clientgen_level,
        client_subgrpid: element.dimensionAttributeValues.client_subgrpid,
        client_lerctcode: element.dimensionAttributeValues.client_lerctcode,
        client_grpid: element.dimensionAttributeValues.client_grpid,
        client_grpcomcontinentname:
          element.dimensionAttributeValues.client_grpcomcontinentname,
        client_grpcomctrygrpname:
          element.dimensionAttributeValues.client_grpcomctrygrpname,
        client_grpcountryaxis:
          element.dimensionAttributeValues.client_grpcountryaxis,
        client_grpfupclasslabel:
          element.dimensionAttributeValues.client_grpfupclasslabel,
        client_grpsegment: element.dimensionAttributeValues.client_grpsegment,
        client_grptypl1name:
          element.dimensionAttributeValues.client_grptypl1name,
        client_grptypl2name:
          element.dimensionAttributeValues.client_grptypl2name,
        client_grptypl3name:
          element.dimensionAttributeValues.client_grptypl3name,
        gbis_level_1_functional_label:
          element.dimensionAttributeValues.gbis_level_1_functional_label,
        gbis_level_6_functional_label:
          element.dimensionAttributeValues.gbis_level_6_functional_label,
        gbis_level_7_functional_label:
          element.dimensionAttributeValues.gbis_level_7_functional_label,
        nbi_ytd: Functions.formatMoney(element.indicatorKpiValues.nbi_ytd),
        nbi_h1: Functions.formatMoney(element.indicatorKpiValues.nbi_h1),
        nbi_ytd_1: Functions.formatMoney(element.indicatorKpiValues.nbi_ytd_1),
        nbi_ytd_2_gbis: Functions.formatMoney(
          element.indicatorKpiValues.nbi_ytd_2_gbis
        ),
        nbi_ytd_3_gbis: Functions.formatMoney(
          element.indicatorKpiValues.nbi_ytd_3_gbis
        ),
        nbi_mtd: Functions.formatMoney(element.indicatorKpiValues.nbi_mtd),
        nbi_mtd_1: Functions.formatMoney(element.indicatorKpiValues.nbi_mtd_1),
        nbi_fy_1: Functions.formatMoney(element.indicatorKpiValues.nbi_fy_1),
        nbi_fy_2: Functions.formatMoney(element.indicatorKpiValues.nbi_fy_2),
        nbi_nbi: Functions.formatMoney(element.indicatorKpiValues.nbi_nbi),
        nbi_yoy: Functions.formatMoney(element.indicatorKpiValues.nbi_yoy),
        nbi_ytd_2: Functions.formatMoney(element.indicatorKpiValues.nbi_ytd_2),
        nbi_ytd_3: Functions.formatMoney(element.indicatorKpiValues.nbi_ytd_3),
        nbi_fy_3: Functions.formatMoney(element.indicatorKpiValues.nbi_fy_3),
        nbi_forcast_h1: Functions.formatMoney(
          element.indicatorKpiValues.nbi_forcast_h1
        ),
        nbi_forcast_y1: Functions.formatMoney(
          element.indicatorKpiValues.nbi_forcast_y1
        ),
        nbi_rwa_avg: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_avg
        ),
        nbi_rwa_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_avg,
          true
        ),
        nbi_rwa_fy_1: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_fy_1
        ),
        nbi_rwa_fy_1_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_fy_1,
          true
        ),
        nbi_rwa_fy_2: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_fy_2
        ),
        nbi_rwa_fy_2_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_fy_2,
          true
        ),
        nbi_rwa_fy_3: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_fy_3
        ),
        nbi_rwa_fy_3_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_fy_3,
          true
        ),
        nbi_rwa_last_period: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_last_period
        ),
        nbi_rwa_last_period_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_last_period,
          true
        ),
        nbi_forcast_rwa_h1: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_h1
        ),
        nbi_forcast_rwa_h1_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_h1,
          true
        ),
        nbi_forcast_rwa_y1: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_y1
        ),
        nbi_forcast_rwa_y1_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_y1,
          true
        ),
        nbi_rgcp: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp
        ),
        nbi_rgcp_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp,
          true
        ),
        nbi_forcast_rgcp_h1: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_forcast_rgcp_h1
        ),
        nbi_forcast_rgcp_h1_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_forcast_rgcp_h1,
          true
        ),
        nbi_forcast_rgcp_y1: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_forcast_rgcp_y1
        ),
        nbi_forcast_rgcp_y1_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_forcast_rgcp_y1,
          true
        ),
        nbi_rgcp_1: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_1
        ),
        nbi_rgcp_1_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_1,
          true
        ),
        nbi_rgcp_fy_2: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_fy_2
        ),
        nbi_rgcp_fy_2_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_fy_2,
          true
        ),
        nbi_rgcp_fy_3: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_fy_3
        ),
        nbi_rgcp_fy_3_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_fy_3,
          true
        ),
        nbi_ytd_gbis: Functions.formatMoney(
          element.indicatorKpiValues.nbi_ytd_gbis
        ),
        nbi_ytd_ib: Functions.formatMoney(
          element.indicatorKpiValues.nbi_ytd_ib
        ),
        nbi_ytd_nongbis: Functions.formatMoney(
          element.indicatorKpiValues.nbi_ytd_nongbis
        ),
        nbi_ytd_1_gbis: Functions.formatMoney(
          element.indicatorKpiValues.nbi_ytd_1_gbis
        ),
        nbi_ytd_ib_1: Functions.formatMoney(
          element.indicatorKpiValues.nbi_ytd_ib_1
        ),
        nbi_fy_1_gbis: Functions.formatMoney(
          element.indicatorKpiValues.nbi_fy_1_gbis
        ),
        nbi_fy_1_ib: Functions.formatMoney(
          element.indicatorKpiValues.nbi_fy_1_ib
        ),
        nbi_fy_2_ib: Functions.formatMoney(
          element.indicatorKpiValues.nbi_fy_2_ib
        ),
        nbi_fy_3_ib: Functions.formatMoney(
          element.indicatorKpiValues.nbi_fy_3_ib
        ),
        nbi_forcast_y1_gbis: Functions.formatMoney(
          element.indicatorKpiValues.nbi_forcast_y1_gbis
        ),
        nbi_forcast_y1_ib: Functions.formatMoney(
          element.indicatorKpiValues.nbi_forcast_y1_ib
        ),
        nbi_forcast_y1_nongbis: Functions.formatMoney(
          element.indicatorKpiValues.nbi_forcast_y1_nongbis
        ),
        nbi_rwa_gbis: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_gbis
        ),
        nbi_rwa_gbis_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_gbis,
          true
        ),
        nbi_rwa_fy_1_gbis: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_fy_1_gbis
        ),
        nbi_rwa_fy_1_gbis_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_rwa_fy_1_gbis,
          true
        ),
        nbi_forcast_rwa_h1_gbis: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_h1_gbis
        ),
        nbi_forcast_rwa_h1_gbis_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_h1_gbis,
          true
        ),
        nbi_forcast_rwa_h1_nongbis: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_h1_nongbis
        ),
        nbi_forcast_rwa_h1_nongbis_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_h1_nongbis,
          true
        ),
        nbi_forcast_rwa_h1_ib: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_h1_ib
        ),
        nbi_forcast_rwa_h1_ib_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_h1_ib,
          true
        ),
        nbi_forcast_rwa_y1_gbis: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_y1_gbis
        ),
        nbi_forcast_rwa_y1_gbis_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_y1_gbis,
          true
        ),
        nbi_forcast_rwa_y1_nongbis: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_y1_nongbis
        ),
        nbi_forcast_rwa_y1_nongbis_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_y1_nongbis,
          true
        ),
        nbi_forcast_rwa_y1_ib: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_y1_ib
        ),
        nbi_forcast_rwa_y1_ib_export: Functions.formatMoneyByMillion(
          element.indicatorKpiValues.nbi_forcast_rwa_y1_ib,
          true
        ),
        nbi_rgcp_gbis: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_gbis
        ),
        nbi_rgcp_gbis_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_gbis,
          true
        ),
        nbi_forcast_rgcp_h1_gbis: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_forcast_rgcp_h1_gbis
        ),
        nbi_forcast_rgcp_h1_gbis_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_forcast_rgcp_h1_gbis,
          true
        ),
        nbi_forcast_rgcp_y1_gbis: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_forcast_rgcp_y1_gbis
        ),
        nbi_forcast_rgcp_y1_gbis_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_forcast_rgcp_y1_gbis,
          true
        ),
        nbi_rgcp_fy_1_gbis: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_fy_1_gbis
        ),
        nbi_rgcp_fy_1_gbis_export: Functions.formatNoDecimal(
          element.indicatorKpiValues.nbi_rgcp_fy_1_gbis,
          true
        ),
        nbi_fy_var_yoy: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_ytd,
          element.indicatorKpiValues.nbi_fy_1
        ),
        nbi_fy_var_yoy_export: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_ytd,
          element.indicatorKpiValues.nbi_fy_1,
          true
        ),
        nbi_ytd_var_yoy: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_ytd,
          element.indicatorKpiValues.nbi_ytd_1
        ),
        nbi_ytd_var_yoy_export: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_ytd,
          element.indicatorKpiValues.nbi_ytd_1,
          true
        ),
        nbi_forcast_y1_var_yoy: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_forcast_y1,
          element.indicatorKpiValues.nbi_fy_1
        ),
        nbi_forcast_y1_var_yoy_export: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_forcast_y1,
          element.indicatorKpiValues.nbi_fy_1,
          true
        ),
        nbi_rwa_vs_fy_1: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_rwa_avg,
          element.indicatorKpiValues.nbi_rwa_fy_1
        ),
        nbi_rwa_vs_fy_1_export: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_rwa_avg,
          element.indicatorKpiValues.nbi_rwa_fy_1,
          true
        ),
        nbi_forecast_rwa_y1_vs_fy_1: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_forcast_rwa_y1,
          element.indicatorKpiValues.nbi_rwa_fy_1
        ),
        nbi_forecast_rwa_y1_vs_fy_1_export: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_forcast_rwa_y1,
          element.indicatorKpiValues.nbi_rwa_fy_1,
          true
        ),
        nbi_rgcp_vs_fy_1: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_rgcp,
          element.indicatorKpiValues.nbi_rgcp_1
        ),
        nbi_rgcp_vs_fy_1_export: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_rgcp,
          element.indicatorKpiValues.nbi_rgcp_1,
          true
        ),
        nbi_gbis_bud_obj: Functions.formatMoneyWithoutDecimal(
          element.indicatorKpiValues.nbi_gbis_bud_obj
        ),
        nbi_ytd_vs_nbi_gbis_bud_obj: Functions.calculateProgress(
          element.indicatorKpiValues.nbi_ytd,
          element.indicatorKpiValues.nbi_gbis_bud_obj
        ),
        nbi_gbis_bud_obj_ib: Functions.formatMoneyWithoutDecimal(
          element.indicatorKpiValues.nbi_gbis_bud_obj_ib
        ),
        nbi_ytd_vs_nbi_gbis_bud_obj_ib: Functions.calculateVariation(
          element.indicatorKpiValues.nbi_ytd_ib,
          element.indicatorKpiValues.nbi_gbis_bud_obj_ib
        ),
        nbi_scbased_fy_1: Functions.formatMoney(
          element.indicatorKpiValues.nbi_scbased_fy_1
        ),
        nbi_scbased_fy_2: Functions.formatMoney(
          element.indicatorKpiValues.nbi_scbased_fy_2
        ),
        nbi_scbased_fy_1_ib: Functions.formatMoney(
          element.indicatorKpiValues.nbi_scbased_fy_1_ib
        ),
        nbi_scbased_fy_2_ib: Functions.formatMoney(
          element.indicatorKpiValues.nbi_scbased_fy_2_ib
        ),
      });
    }
  });
  return new NbiClientListOutput(topValues);
}

//#region Headers

export function getDefaultHeaders(widgetName: string) {
  const defaultAttributes: any = [];

  const defaultAttributesFields = [
    "nbi_mtd",
    "nbi_ytd",
    "nbi_ytd_1",
    "nbi_ytd_var_yoy",
    "nbi_fy_1",
    "nbi_mtd_1",
    "nbi_rwa_avg",
    "nbi_rgcp",
    "nbi_forcast_h1",
    "nbi_h1",
    "nbi_forcast_y1",
    "nbi_forcast_rwa_y1",
    "nbi_rwa_vs_fy_1",
    "nbi_rgcp_1",
    "nbi_rgcp_vs_fy_1",
  ];
  if (widgetName === widgetNames.PORTFOLIO) {
    defaultAttributesFields.push("fpv_bl", "fpv_sbl");
  } else if (widgetName === widgetNames.CLIENTSNAPSHOT) {
    defaultAttributesFields.push("clientgen_name");
  } else {
    defaultAttributesFields.push("client_grpname");
  }

  const allHeaders = getAllHeaders(widgetName);
  for (const attribute of defaultAttributesFields) {
    let attrInfos = allHeaders.attributeHeaders.filter(
      (entry: any) => entry.field === attribute
    );
    if (attrInfos.length === 0) {
      attrInfos = allHeaders.kpiHeaders.filter(
        (entry: any) => entry.field === attribute
      );
    }
    if (attrInfos.length > 0) {
      defaultAttributes.push(attrInfos[0]);
    }
  }
  return defaultAttributes;
}

export function GetHyperLinkForField(
  field: string[],
  dateForFilter: string[] | undefined,
  filterIds: string[] = [FilterIdentifier.client_selector],
  userSelectionIds: string[] = [FilterUserSelection.client_selector],
  boardId: string = BoardIds.Client_Card
): string | undefined {
  const hFilterTypes: any = [];
  const fieldFilters: string[][] = [];

  for (const iterator of field) {
    const fieldFilter = [];
    fieldFilter.push(iterator);
    fieldFilters.push(fieldFilter);
  }

  if (fieldFilters.length > 0) {
    for (let index = 0; index < filterIds.length; index++) {
      if (fieldFilters[index] && fieldFilters[index].length > 0) {
        hFilterTypes.push({
          filter_id: filterIds[index],
          id: userSelectionIds[index],
          value: fieldFilters[index],
        });
      }
    }

    if (dateForFilter) {
      hFilterTypes.push({
        filter_id: FilterIdentifier.asOfDate,
        id: FilterUserSelection.asOfDate,
        value: dateForFilter,
      });
    }
    const hFilter: IGenericHyperlinkFilter = {
      board_id: boardId,
      filter: hFilterTypes,
    };
    return BuildUrlForHyperlinkInGrid(hFilter);
  }
}

export const widgetNames = {
  CLIENTGROUP: "clientgroup",
  CLIENTSNAPSHOT: "clientsnapshot",
  PORTFOLIO: "portfolio",
};
